export default __webpack_public_path__ + "static/media/users.e791185e.svg";